import React from "react";
import { List } from "@mui/material";
import { matchPath } from "react-router-dom";
import SidebarPageItem from "./sidebar-page-item";
import { SidebarItem, SidebarNestedItem } from "./sidebar-elements";
import NestedSidebarItem from "./nested-item";
import useCanShowItem from "./use-can-show-item";

interface SidebarPageItemWrapperProps {
  item: SidebarItem;
  mini: boolean;
  isFullyExpanded: boolean;
  expanded: boolean;
  pathname: string;
  handlePageItemClick: (id: string, hasNested: boolean) => void;
}

const SidebarPageItemWrapper: React.FC<SidebarPageItemWrapperProps> = ({
  item,
  mini,
  isFullyExpanded,
  expanded,
  pathname,
  handlePageItemClick,
}) => {
  const canShowItem = useCanShowItem();

  if (
    !canShowItem({
      requiredPermission: item.requiredPermission,
      ldFlag: item.ldFlag,
    })
  )
    return null;

  return (
    <SidebarPageItem
      item={item}
      selected={!!matchPath(`${item.href}/*`, pathname)}
      defaultExpanded={!!matchPath(`${item.href}/*`, pathname)}
      expanded={expanded}
      mini={mini}
      fullyExpanded={isFullyExpanded}
      fullyCollapsed={!expanded}
      onToggle={() => handlePageItemClick(item.id, !!item.nestedNavigation)}
      nestedNavigation={
        item.nestedNavigation ? (
          <List
            dense
            sx={{ padding: 0, my: 1, pl: mini ? 0 : 1, minWidth: 240 }}
          >
            {item.nestedNavigation.map((nestedItem: SidebarNestedItem) => (
              <NestedSidebarItem
                key={nestedItem.title}
                item={{
                  ...nestedItem,
                  id: nestedItem.title.toLowerCase().replaceAll(" ", "-"),
                }}
                mini={mini}
                isFullyExpanded={isFullyExpanded}
                expanded={expanded}
                pathname={pathname}
                handlePageItemClick={handlePageItemClick}
              />
            ))}
          </List>
        ) : undefined
      }
    />
  );
};

export default React.memo(SidebarPageItemWrapper);
